module.exports = __webpack_public_path__ + "favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/favicons/favicon.ico
 ** module id = ./assets/favicons/favicon.ico
 ** module chunks = 2
 **/